import { render } from "./ProfileLeft.vue?vue&type=template&id=760b8768&scoped=true&ts=true"
import script from "./ProfileLeft.vue?vue&type=script&lang=ts"
export * from "./ProfileLeft.vue?vue&type=script&lang=ts"

import "./ProfileLeft.vue?vue&type=style&index=0&id=760b8768&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760b8768"]])

export default __exports__